import React from 'react';
import Input from '../Common/Input';
import InputMask from '../Common/InputMask';

const Form = ({ formik }) => {

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">

                <div className="col-md-3">
                    <Input label="عنوان" name="title" required={true} formik={formik} />
                </div>
                <div className="col-md-6">
                    <Input label="آدرس" name="address" required={true} formik={formik} />
                </div>
                <div className="col-md-3">
                    <InputMask label="شماره تماس" name="phone" required={true} formik={formik} isLtr={true} mask="999-99999999" />
                </div>

            </div>

        
            <button className="btn btn-success" id="btn-submit-form">ذخیره اطلاعات</button>
        </form>
    );
}

export default Form;